import React from 'react'

import { useGetWorkspaceProfileQuery } from '@sketch/gql-types'
import { Skeleton, ErrorMessage } from '@sketch/components'
import { HideProfileSection } from './HideProfileSection'
import { PublishProfileSection } from './PublishProfileSection'

export interface WorkspaceSettingsProfileProps {
  workspaceId: string
}

export const WorkspaceSettingsProfileQuery: React.FC<WorkspaceSettingsProfileProps> = props => {
  const { workspaceId } = props

  const { data, error } = useGetWorkspaceProfileQuery({
    variables: { workspaceIdentifier: workspaceId },
  })

  const { identifier, isPublic } = data?.workspaceProfile ?? {
    identifier: '',
    isPublic: undefined,
  }

  if (error) {
    return <ErrorMessage.Generic />
  }

  if (isPublic === undefined) {
    return <Skeleton width="100%" height="70px" />
  }

  if (isPublic) return <HideProfileSection identifier={identifier} />

  return <PublishProfileSection identifier={identifier} />
}
